import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import { FulfillmentStatusBadge } from "@/features/marketplace/components/FulfillmentStatusBadge";
import type { MarketplaceFulfillmentViewer } from "@/features/marketplace/lib/fulfillment-badge-variant";
import { orderLineVideoFulfillmentStatus } from "@/features/marketplace/lib/video-display-status";
import type { OrderLineVideo } from "@/features/marketplace/types/marketplace.types";

export function OrderLineVideoStatusBadge({
  scriptFulfillmentStatus,
  video,
  videos,
  viewer = "partner",
}: {
  scriptFulfillmentStatus: MarketplaceFulfillmentStatus;
  video: OrderLineVideo;
  /** All videos on the script — required for mixed revision / re-upload rows. */
  videos?: readonly OrderLineVideo[];
  viewer?: MarketplaceFulfillmentViewer;
}) {
  const status =
    video.fulfillmentStatus ??
    orderLineVideoFulfillmentStatus(scriptFulfillmentStatus, video, { videos });
  if (!status) return null;
  return <FulfillmentStatusBadge status={status} viewer={viewer} />;
}
